<template>
  <tag-icon-svg class="hydrated"
    ><div class="tag-icon--access" style="height: 24px; width: 24px">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        style="height: 24px; width: 24px"
        fill="#e5173f"
      >
        <defs></defs>
        <path
          d="M23,11.5l-7.13-6.375h0A8.228,8.228,0,0,0,10.347,3,8.425,8.425,0,0,0,2,11.5,8.426,8.426,0,0,0,10.347,20a8.221,8.221,0,0,0,5.521-2.126h0L23,11.5m-18.465,0a5.868,5.868,0,0,1,5.814-5.92,5.921,5.921,0,0,1,0,11.839A5.868,5.868,0,0,1,4.533,11.5Z"
        ></path>
      </svg></div
  ></tag-icon-svg>
</template>
>
